import { AssetReference } from './creativeset/element-asset';
export function getObjectKeys(object) {
    return Object.keys(object);
}
export const INLINE_STYLED_TEXT = 'inline-styled-text';
export const sharedPropertyToUnitMap = {
    name: 'string',
    x: 'number',
    y: 'number',
    width: 'number',
    height: 'number',
    duration: 'number',
    fill: 'Color',
    originX: 'number',
    originY: 'number',
    rotationX: 'number',
    rotationY: 'number',
    rotationZ: 'number',
    radius: 'Radius',
    opacity: 'number',
    shadows: 'Shadow[]',
    filters: 'FilterMap',
    border: 'Border',
    hidden: 'boolean',
    locked: 'boolean',
    mirrorX: 'boolean',
    mirrorY: 'boolean',
    scaleX: 'number',
    scaleY: 'number',
    ratio: 'number',
    feed: 'Feed',
    states: 'State[]',
    animations: 'Animation[]',
    actions: 'Action[]',
    time: 'number',
    masking: 'Masking'
};
export const characterPropertyToUnitMap = {
    font: 'FontStyle',
    textColor: 'Color',
    fontSize: 'number',
    lineHeight: 'number',
    characterSpacing: 'number',
    uppercase: 'boolean',
    underline: 'boolean',
    strikethrough: 'boolean',
    textShadows: 'TextShadow[]',
    variable: 'Feed',
    __fontFamilyId: 'string'
};
const textPropertiesOnlyToUnitMap = {
    maxRows: 'number',
    padding: 'Padding',
    textOverflow: 'enum',
    horizontalAlignment: 'enum',
    verticalAlignment: 'enum',
    textColor: 'Color',
    font: 'FontStyle',
    fontSize: 'number',
    lineHeight: 'number',
    characterSpacing: 'number',
    uppercase: 'boolean',
    underline: 'boolean',
    strikethrough: 'boolean',
    textShadows: 'TextShadow[]',
    content: 'text',
    // A helper property to display, font family in dropdown, when font style is undefined.
    __fontFamilyId: 'string'
};
export const textPropertyToUnitMap = Object.assign(Object.assign({}, characterPropertyToUnitMap), textPropertiesOnlyToUnitMap);
export const textStyleProperties = [
    'maxRows',
    'padding',
    'textOverflow',
    'horizontalAlignment',
    'verticalAlignment',
    'textColor',
    'font',
    'fontSize',
    'lineHeight',
    'characterSpacing',
    'uppercase',
    'underline',
    'strikethrough',
    'textShadows',
    'width',
    'height',
    // A helper property to display, font family in dropdown, when font style is undefined.
    '__fontFamilyId'
];
export const widgetPropertyToUnitMap = {
    js: 'string',
    html: 'string',
    css: 'string',
    customProperties: 'CustomProperty[]',
    [AssetReference.Widget]: 'string',
    [AssetReference.BannerflowLibraryWidget]: 'string'
};
export const widgetCustomPropertyToUnitMap = {
    text: 'WidgetText',
    number: 'number',
    boolean: 'boolean',
    select: 'CustomProperty[]',
    image: 'ImageAsset',
    feed: 'Feed',
    font: 'FontStyle',
    color: 'Color',
    widgetText: 'WidgetText'
};
const imagePropertyToUnitMap = {
    [AssetReference.Image]: 'string',
    imageAsset: 'ImageAsset',
    imageSettings: 'ImageSettings'
};
const videoPropertyToUnitMap = {
    videoAsset: 'VideoAsset',
    videoSettings: 'VideoSettings'
};
export const statePropertyToUnitMap = {
    name: 'string',
    x: 'number',
    y: 'number',
    scaleX: 'number',
    scaleY: 'number',
    opacity: 'number',
    mirrorX: 'boolean',
    mirrorY: 'boolean',
    rotationX: 'number',
    rotationY: 'number',
    rotationZ: 'number',
    originX: 'number',
    originY: 'number',
    ratio: 'number',
    textColor: 'Color',
    border: 'Border',
    shadows: 'Shadow[]',
    radius: 'Radius',
    fill: 'Color',
    filters: 'FilterMap'
};
/** Mutatable properties */
export const propertyToUnitMap = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, sharedPropertyToUnitMap), textPropertyToUnitMap), widgetPropertyToUnitMap), imagePropertyToUnitMap), videoPropertyToUnitMap), statePropertyToUnitMap);
export const propertyKeys = getObjectKeys(propertyToUnitMap);
export const textProperties = [
    'content',
    'horizontalAlignment',
    'verticalAlignment',
    'font',
    'fontSize',
    'maxRows',
    'padding',
    'textOverflow',
    'textColor',
    'uppercase',
    'underline',
    'strikethrough',
    'characterSpacing',
    'lineHeight',
    'textShadows',
    '__fontFamilyId'
];
export const characterProperties = [
    '__fontFamilyId',
    'characterSpacing',
    'font',
    'fontSize',
    'lineHeight',
    'strikethrough',
    'textColor',
    'textShadows',
    'underline',
    'uppercase'
];
export const unitToVersionedUnitMap = {
    text: 'widgetText',
    feed: 'feed'
};
export const serializableSharedProperties = [
    'actions',
    'animations',
    'border',
    'duration',
    'fill',
    'filters',
    'height',
    'hidden',
    'locked',
    'mirrorX',
    'mirrorY',
    'opacity',
    'originX',
    'originY',
    'radius',
    'ratio',
    'rotationX',
    'rotationY',
    'rotationZ',
    'scaleX',
    'scaleY',
    'shadows',
    'states',
    'time',
    'width',
    'x',
    'y'
];
export const serializableTextProperties = [
    'characterSpacing',
    'characterStyles',
    'font',
    'fontSize',
    'horizontalAlignment',
    'lineHeight',
    'maxRows',
    'padding',
    'strikethrough',
    'textColor',
    'textOverflow',
    'textShadows',
    'underline',
    'uppercase',
    'verticalAlignment'
];
export const serializableStateProperties = [
    'border',
    'fill',
    'filters',
    'id',
    'mirrorX',
    'mirrorY',
    'name',
    'opacity',
    'originX',
    'originY',
    'radius',
    'ratio',
    'rotationX',
    'rotationY',
    'rotationZ',
    'scaleX',
    'scaleY',
    'shadows',
    'textColor',
    'x',
    'y'
];
export const serializableImageProperties = [
    'imageAssetId',
    'imageSettings'
];
export const serializableVideoProperties = [
    'videoAssetId',
    'videoSettings'
];
export const serializableWidgetProperties = ['customProperties'];
export const serializableWidgetCustomProperties = [
    'text',
    'number',
    'boolean',
    'select',
    'image',
    'feed',
    'font',
    'color'
];
export const serializableProperties = [
    ...serializableSharedProperties,
    ...serializableStateProperties,
    ...serializableImageProperties,
    ...serializableVideoProperties,
    ...serializableWidgetProperties,
    ...serializableTextProperties
];
